import { Button } from 'features/common/components/Button';
import { Divider } from 'features/common/components/Divider';
import { Form } from 'features/common/components/Form';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
	padding: 20px 3% 40px;
	overflow: auto;
`;

export const Container = styled(Form)<{ isPunchup?: boolean }>`
	display: flex;
	align-items: stretch;
	flex-direction: column;
	padding: ${({ isPunchup }) => (isPunchup ? '0' : '64px')};
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 0;
		width: 99%;
	}
`;

export const DividerWithSpacing = styled(Divider)`
	margin: 48px 0;
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		margin: 32px 0;
	}
`;

export const PublishButton = styled(Button)`
	width: 250px;
	display: flex;
	justify-content: center;
	align-self: center;
	margin: 0;
	font-weight: 600;
	font-size: 18px;
	padding: 12px 24px;
`;
